import React, { useEffect } from "react";

import "./CheckoutSuccess.scss";

const CheckoutSuccess = () => {
  useEffect(() => {
    localStorage.removeItem("localCart");
  }, []);

  return (
    <section className="checkout-success">
      <div className="checkout-success__header">
        <div className="elipse elipse--green">
          <svg
            className="elipse__tick-mark"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.40234 6.91086L3.68382 9.1029C3.91488 9.32491 4.2811 9.32124 4.50768 9.09466L12.6023 1"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
        <p className="checkout-success__header__title">¡Listo!</p>
        <p className="checkout-success__header__label">
          Tu pedido fue enviado exitosamente.
        </p>
      </div>
      <p className="checkout-success__copy">
        Nos pondremos en contacto por whatsapp para confirmar y coordinar tu
        pedido.
      </p>
      <a
        className="checkout-success__wpp-cta"
        target="_blank"
        href="https://web.whatsapp.com/"
      >
        Abrir tu whatsapp web
      </a>
    </section>
  );
};

export default CheckoutSuccess;
